import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import * as events from '../../../events'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import NoWait from '../../atoms/no-wait'

import { Bottom, Wrapper } from './styles'

import s from './strings'

type Props = {
  trackInstantDashSplashViewed?: () => Promise<any>
  trackWebviewClosed?: () => Promise<any>
}

export const InstantDashSplash: React.FC<Props> = ({
  trackInstantDashSplashViewed,
  trackWebviewClosed,
}) => {
  const os = detectWebviewOs()
  React.useEffect(() => {
    trackInstantDashSplashViewed()
  }, [trackInstantDashSplashViewed])

  return (
    <Wrapper>
      <StackChildren>
        <NoWait />
        <Text styles={Text.Styles.Bold32}>{s.title()}</Text>
        <Text styles={Text.Styles.Medium24}>{s.subtitle()}</Text>
      </StackChildren>
      <Bottom>
        <StackChildren>
          <Text styles={Text.Styles.ContentBody}>{s.body()}</Text>
          <Button
            type={Button.Types.PrimaryPill}
            size={Button.Sizes.Large}
            tag="a"
            href={
              os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
            }
            onClick={trackWebviewClosed}
          >
            {s.button()}
          </Button>
        </StackChildren>
      </Bottom>
    </Wrapper>
  )
}

InstantDashSplash.defaultProps = {
  // tslint:disable:no-console
  trackInstantDashSplashViewed: () =>
    Promise.resolve(console.log('track activation splash viewed')),
  trackWebviewClosed: () =>
    Promise.resolve(console.log('track webview closed')),
  // tslint:enable:no-console
}

const mapDispatchToProps = {
  trackInstantDashSplashViewed: events.trackInstantDashSplashViewed,
  trackWebviewClosed: events.trackWebviewClosed,
}

export default connect(null, mapDispatchToProps)(InstantDashSplash)
